import Grid from '@jobcost-monorepo/crud/ui/Grid';
import { IJob, IListJobFetchParams, MN_JOBS } from '@jobcost-monorepo/crud';

export default function JobsPage() {
  return (
    <Grid<IJob, IListJobFetchParams>
      moduleName={MN_JOBS}
      updateStore={false}
    ></Grid>
  );
}
